import Log from "../view/log";
import MonitoringPointManagement from "../view/FaceRecognition/MonitoringPointManagement/MonitoringPointManagement";
import MonitoringPointManagementAdd from "../view/FaceRecognition/MonitoringPointManagement/MonitoringPointManagementAdd";
import MonitoringPointManagementModify from "../view/FaceRecognition/MonitoringPointManagement/MonitoringPointManagementModify";
import FaceDetection from "../view/FaceRecognition/FaceDetection/FaceDetection";
import FaceDatabaseManagement from "../view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseManagement";
import FaceDatabaseAuthorization from "../view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseAuthorization";
import FaceDatabaseAuthorizationBlack from "../view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseAuthorizationBlack";
import LicenseLogging from "../view/FaceRecognition/LicenseLogging/LicenseLogging";
import IdentificationLogging from "../view/FaceRecognition/IdentificationLogging/IdentificationLogging";
import ImageCollections from "../view/FaceRecognition/ImageCollections/ImageCollections";
import FaceRecognitionNav from "../view/FaceRecognition/FaceRecognitionNav";

export default [
  {
    path: "/monitoring_point_management",
    name: "monitoring-point-management",
    components: {
      default: FaceRecognitionNav,
      a: MonitoringPointManagement
    }
  },
  {
    path: "/monitoring_point_management_add",
    name: "monitoring-point-management-add",
    components: {
      default: FaceRecognitionNav,
      a: MonitoringPointManagementAdd
    }
  },
  {
    path: "/monitoring_point_management_modify/:id",
    name: "monitoring-point-management-modify",
    components: {
      default: FaceRecognitionNav,
      a: MonitoringPointManagementModify
    }
  },
  {
    path: "/face_detection",
    name: "face-detection",
    components: {
      default: FaceRecognitionNav,
      a: FaceDetection
    }
  },
  {
    path: "/face_database_management",
    name: "face-database-management",
    components: {
      default: FaceRecognitionNav,
      a: FaceDatabaseManagement
    }
  },
  {
    path: "/face_database_authorization/:id",
    name: "face-database-authorization",
    components: {
      default: FaceRecognitionNav,
      a: FaceDatabaseAuthorization
    }
  },
  {
    path: "/face_database_authorization_black/:id",
    name: "face-database-authorization-black",
    components: {
      default: FaceRecognitionNav,
      a: FaceDatabaseAuthorizationBlack
    }
  },
  {
    path: "/license_logging",
    name: "license-logging",
    components: {
      default: FaceRecognitionNav,
      a: LicenseLogging
    }
  },
  {
    path: "/identification_logging",
    name: "identification-logging",
    components: {
      default: FaceRecognitionNav,
      a: IdentificationLogging
    }
  },
  {
    path: "/image_collections",
    name: "image-collections",
    components: {
      default: FaceRecognitionNav,
      a: ImageCollections
    }
  },
  {
    path: "/face_log",
    name: "face-log",
    components: {
      default: FaceRecognitionNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/FaceRecognition.js